import CategoriesDirectory from "../../components/categories-directory/Categories-directory.component";

const Home = () => {
  return <CategoriesDirectory />;
};

export default Home;
